import { type UPLOAD_TYPES } from "../../../Workers/Upload/UploadEvents";
import { type BaseUploadRepository } from "../../_Bases/BaseUploadRepository";
import { type QueuedItem } from "../../_Bases/BaseUploadRepository";
import { type InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBUploadRepository extends BaseIndexedDBRepository<
    QueuedItem<UPLOAD_TYPES>,
    number
> implements BaseUploadRepository {
    public readonly source: InternalIndexedDBDatabase["uploads"];
    protected readonly dataTypeName = "Upload";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.uploads;
    }

    public getFailedUploads(retryLimit: number): Promise<Array<QueuedItem<UPLOAD_TYPES>>> {
        return this.source
            .where("attempts")
            .aboveOrEqual(retryLimit)
            .and((item) => {
                return !item.dismissed;
            })
            .toArray();
    }

    public dismissErrors(ids: Array<number>): Promise<void> {
        return this.source
            .where("id")
            .anyOf(ids)
            .modify({
                dismissed: true,
            })
            .then(() => {
                // Return void
            });
    }

    public resetIdempotence(): Promise<void> {
        return this.source.toArray()
            .then(async queue => {
                for(let i = 0, l = queue.length; i < l; i++) {
                    await this.source.put({
                        ...queue[i],
                        requestId: undefined,
                    });
                }
            });
    }

    public resetAttempts(): Promise<void> {
        return this.source.toArray()
            .then(async queue => {
                for(let i = 0, l = queue.length; i < l; i++) {
                    await this.source.put({
                        ...queue[i],
                        attempts: 0,
                    });
                }
            });
    }

    public getQueue(retryLimit: null | number): Promise<Array<QueuedItem<UPLOAD_TYPES>>> {
        let query: any = this.source;

        if(retryLimit !== null) {
            query = query.where("attempts")
                .below(retryLimit);
        }

        return query.toArray();
    }
}
